App.controller('LifeWithPaymentsStartCtrl', ['$scope', '$sce', '$state', '$http', '$stateParams', '$timeout', 'popUpService', function ($scope, $sce, $state, $http, $stateParams, $timeout, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Ubezpieczenie na życie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $timeout(function () {
        if (!$('.menu.menu_2').hasClass('open')) {
            $('a[target=".menu_2"]').trigger('click');
        }
    }, 0);

    popUpService.showPopUp({
        ev: '',
        head: '',
        content: 'Uruchomiliśmy nową wersję systemu do obsługi kontynuacji ubezpieczenia.<br/>' +
            'Od teraz możesz przystąpić do ubezpieczenia pod adresem: <a href="https://kontynuacja.xilium.pl">https://kontynuacja.xilium.pl</a>',
        text: 'Zamknij',
        target: '',
        tpl: 'info-big',
        clickOutsideToClose: false,
    });

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.summary = $scope.stateParams.summary;
        $scope.persons = $scope.stateParams.persons;
    } else {
        $scope.summary = 0;
    }

    $scope.allLength = 0;
    $scope.groupwidth = [];
    $scope.singleLength = [];

    $scope.next = function () {
        $state.go('root.life.variant', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    };
}]);
